import { useEffect, useState, useContext } from 'react';
import { usePublicTracksStore } from '../store/publicTracks.store';
import { useLocation } from 'react-router-dom';
import { FirebaseContext } from '../components/Firebase';
import * as ROUTES from '../constants/routes';

const PublicTracksListener: React.FC = () => {
  const { initTracks, clearTracks } = usePublicTracksStore();
  const location = useLocation();
  const firebase = useContext(FirebaseContext);
  const [user, setUser] = useState<any>(null);

  useEffect(() => {
    if (!firebase) return;
    const unsubscribe = firebase.auth.onAuthStateChanged(async (user: any) => {
      if (user) {
        // Force refresh the ID token to ensure Firestore has valid auth
        await user.getIdToken(true);
        setUser(user);
      } else {
        setUser(null);
        // Clear tracks on logout
        clearTracks();
      }
    });

    return () => unsubscribe();
  }, [firebase, clearTracks]);

  // Initialize public tracks when user is logged in and on public catalogue page
  useEffect(() => {
    if (user && location?.pathname === ROUTES.PUBLIC_CATALOGUE && firebase) {
      initTracks(firebase);
    }
  }, [user, location?.pathname, firebase, initTracks]);

  return null;
};

export default PublicTracksListener;
